/* eslint-disable prefer-destructuring */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import { alertWrapper } from '../../../../utils/alertWrapper';
import { IS_TAB } from '../../../../utils/common';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';
import Carousel from '../../../../components/common/Carousel';

const Decal = ({
  options,
  updatePartsConfig,
  availableCustomizations,
  selectedBaseColorPartId,
  selectedVisorPartId,
  partsConfig,
  selectedPart,
  openAlertDialog
}) => {
  // const [activeDecal, setActiveDecal] = useState(
  //   initialSelectedCustomizationIndex
  // );

  // useActiveStateSelector('decal', options, partsConfig, setActiveDecal);
  // useEffect(() => {
  //   setActiveDecal(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);

  const selectedFinishPartId = Object.keys(partsConfig.finish).find(
    key => partsConfig.finish[key] === true
  );

  let selectedFinishCustomization;
  if (selectedFinishPartId) {
    selectedFinishCustomization = availableCustomizations.finish.filter(
      finish => finish.partId === selectedFinishPartId
    )[0];
  }

  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();

  return (
    <div className="decal">
      {IS_TAB ? (
        <Carousel
          itemWidth={cardWidth || '100'}
          noOfItems={options && options.length}
        >
          {options.map((option, i) => (
            <div
              ref={cardRef}
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`decal-image ${(!option.dependencies.parts.includes(
                selectedBaseColorPartId
              ) ||
                (selectedFinishPartId &&
                  selectedFinishCustomization.collisions.parts.includes(
                    option.partId
                  )) ||
                option.collisions.parts.includes(selectedVisorPartId)) &&
                'decal-image-disabled'} ${selectedPart === option.partId &&
                'decal-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                if (
                  option.dependencies.parts.includes(selectedBaseColorPartId) &&
                  !option.collisions.parts.includes(selectedVisorPartId)
                ) {
                  // setActiveDecal(i);
                  updatePartsConfig(options[i]);
                } else {
                  alertWrapper(
                    {
                      isOpen: true,
                      title: 'Not Available',
                      message:
                        'This decal is not available with selected helmet color. Choose a different color to select this decal.',
                      agreeButtonText: 'Close',
                      isDisagreeAvailable: false,
                      onAgree: () => {},
                      onDisagree: () => {}
                    },
                    openAlertDialog,
                    true
                  );
                }
              }}
            />
          ))}
        </Carousel>
      ) : (
        <GridLayout columns={2}>
          {options.map((option, i) => (
            <div
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`decal-image ${(!option.dependencies.parts.includes(
                selectedBaseColorPartId
              ) ||
                (selectedFinishPartId &&
                  selectedFinishCustomization.collisions.parts.includes(
                    option.partId
                  )) ||
                option.collisions.parts.includes(selectedVisorPartId)) &&
                'decal-image-disabled'} ${selectedPart === option.partId &&
                'decal-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                if (
                  option.dependencies.parts.includes(selectedBaseColorPartId) &&
                  !option.collisions.parts.includes(selectedVisorPartId)
                ) {
                  // setActiveDecal(i);
                  updatePartsConfig(options[i]);
                } else {
                  alertWrapper(
                    {
                      isOpen: true,
                      title: 'Not Available',
                      message:
                        'This decal is not available with selected helmet color. Choose a different color to select this decal.',
                      agreeButtonText: 'Close',
                      isDisagreeAvailable: false,
                      onAgree: () => {},
                      onDisagree: () => {}
                    },
                    openAlertDialog,
                    true
                  );
                }
              }}
            />
          ))}
        </GridLayout>
      )}
    </div>
  );
};

Decal.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object,
  availableCustomizations: PropTypes.array,
  selectedBaseColorPartId: PropTypes.string,
  selectedVisorPartId: PropTypes.string,
  selectedPart: PropTypes.string,
  openAlertDialog: PropTypes.bool
};

export default Decal;
